angular
	.module 'App.Module.Supplier', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'suppliers',
					url: '/suppliers',
					views:
						main:
							templateUrl: '@app/layout/views/app.entity-administration.view.html'
							controller: 'MainCrudController'
							controllerAs: 'mainCrud'

						"entity_search@suppliers":
							templateUrl: '@app/layout/views/app.entity-search.view.html'
							controller: 'BaseSearchController'
							controllerAs: 'search'
					data:
						restrict: 'Backoffice.TopMenu.Inventory.Products'
						searchParams:
							repositoryName: 'SuppliersRepository'
							title: 'general.suppliers'

			.state 'suppliers.edit',
					url: '/:id'
					views:
						entity_view:
							templateUrl: '@app/layout/views/app.entity-container.view.html'
					resolvePolicy: DEFAULT_RESOLVE_POLICY
					resolve:
						supplier: (SuppliersRepository, $stateParams) ->
							return SuppliersRepository.getEntity($stateParams.id)
						purchaseOrders: (PurchaseOrderRepository, $stateParams) ->
							return [] if _.isEmpty $stateParams.id

							query = PurchaseOrderRepository.createQuery()
							query.criteria 'supplier_id', '=', $stateParams.id
							query.with 'shop', 'stock_location'
							query.sortBy 'expected_delivery_time', 'DESC'

							return PurchaseOrderRepository.getEntities(query)

			.state 'suppliers.edit.details',
					url: '/edit',
					views:
						entity_sub_view:
							controller: 'SupplierController'
							controllerAs: 'vm'
							templateUrl: '@app/supplier/supplier.view.html'
